<mat-toolbar class="mat-toolbar mat-toolbar-single-row">
  <img class="logo logo-h" src="/assets/img/allegion-logo@1x.png" />
  <img class="logo logo-a" src="/assets/img/allegion-a.png" />
</mat-toolbar>
